module.exports = __webpack_public_path__ + "img/new-cod-disabled.0d53c567.svg";